import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import VideoModal from '@/components/common/VideoModal';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { Container, Slider } from '@pwskills/rachnaui';
import PlayIcon from '@pwskills/rachnaui/Icons/Play';
import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import TestimonialCard from './TestimonialCard';
import Headers from '../../Header';
import { dataLayer } from '../../../../utils/common/dataLayer.utils';

const AlumniTestimonialTextType = ({ isAmateur = true }: { isAmateur?: boolean }) => {
  const [modelOpen, setModelOpen] = useState<boolean>(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { testimonials, alumniTestimonial } = courseDetails?.courseMetaDetails || {};
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const sendDataLayerEvent = (videoURL: string, section: string) => {
    const dataLayerObj = {
      event: 'video_click',
      section_name: section,
      course_id: courseDetails?._id,
      video_url: videoURL,
    };
    dataLayer(dataLayerObj);
  };
  const returnChildren = () => {
    return (
      <>
        {' '}
        <div className="hidden large:flex large:!absolute top-1/4 right-12">
          <picture className="pb-4">
            <img
              src="/images/campusEdgeCourseDescription/main/blob-maroon.svg"
              alt="blob-1"
              width={24}
              height={24}
              className="absolute top-[-35px] right-[150px]"
            />
          </picture>
          <picture className="pl-10">
            <img
              src="/images/campusEdgeCourseDescription/main/blob-green.svg"
              alt="blob-2"
              width={80}
              height={80}
            />
          </picture>
        </div>
        <VideoModal
          title="Alumni Testimonial"
          modalOpen={modelOpen}
          setModelOpen={setModelOpen}
          videoUrl={alumniTestimonial?.videoUrl as string}
          section="alumni_testimonies"
        />
        {isAmateur && (
          <header className="flex justify-center text-[#3D3D3D]">
            <Headers
              title="Alumni's Testimonies"
              classes="flex !min-w-full w-full justify-center text-gray-850 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full"
            />
          </header>
        )}
        {!isAmateur && (
          <ProfessionalThemeHeader
            title="Champions of Change: Alumni Experiences"
            subtitle="Unlock the potential within our alumni's experiences and witness the transformative power of upscaling on their careers and lives"
          />
        )}
        <div className="flex flex-col medium:!flex-row medium:!items-center medium:!justify-start  gap-x-[17px] relative gap-y-6">
          <article
            className="w-full medium:!min-w-[332px]  medium:!max-w-[332px]  large:!min-w-[410px] large:!max-w-[410px]  h-auto relative  self-start "
            onClick={() => {
              setModelOpen(true);
              sendDataLayerEvent(alumniTestimonial?.videoUrl as string, 'alumni_testimonies');
            }}
            aria-hidden="true"
          >
            <figure className="w-[100%] medium:!h-[248px] relative">
              <img
                src={alumniTestimonial?.thumbnail as string}
                alt={alumniTestimonial?.altText as string}
                width={410}
                height={248}
                className="!w-full !h-full"
              />
            </figure>

            <div className="translate-x-[-50%] w-[42px] h-[42px] flex justify-center items-center rounded-[50%] bg-white translate-y-[-50%] absolute top-[50%] left-[50%] cursor-pointer">
              <PlayIcon className="pl-1 !text-orange-500" />
            </div>
          </article>

          <Slider
            className="flex gap-4 mb-5"
            wrapperClass="gap-6 medium:w-full medium:items-start"
            iconWrapperClass="!p-0 self-end !mx-0 justify-end"
            positionOfSliderInMobile="bottom"
          >
            {testimonials &&
              testimonials.map((testimonial, index) => (
                <TestimonialCard
                  key={testimonial._id}
                  index={index}
                  testimonialImage={testimonial?.testimonialImage || ''}
                  description={testimonial?.description}
                  designation={testimonial.designation}
                  name={testimonial?.name}
                />
              ))}
          </Slider>
        </div>
      </>
    );
  };
  return (
    <section
      id="testimonial"
      data-title="Testimonial"
      className={isDashboard ? '' : ' bg-blue-50 relative'}
    >
      {isDashboard ? (
        <div className="p-4 flex flex-col">{returnChildren()}</div>
      ) : (
        <Container className="relative medium:!px-8 large:!px-20 py-9 medium:py-14  flex flex-col gap-6">
          {returnChildren()}
        </Container>
      )}
    </section>
  );
};

export default AlumniTestimonialTextType;
